import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { decrypt } from './crypt.helper';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class xKeyIIInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('https://viacep.com.br')) {
      const xKeyII = JSON.parse(decrypt(sessionStorage.getItem(environment.localpoints.authResult))).xKeyII;
      const auth = req.clone({
        headers: req.headers.set('xKeyII', xKeyII)
      });
      return next.handle(auth);
    } else {
      return next.handle(req);
    }
  }
}
